/**
 * Utilidades para la gestión de identificadores de Meta en el navegador.
 * Organizado como objeto para facilitar el mantenimiento y la legibilidad.
 */
export const MarketingCookies = {
  /**
   * Obtiene el valor de cualquier cookie por su nombre.
   * @param name - Nombre de la cookie (ej: "_fbp")
   */
  get(name: string): string | null {
    if (typeof document === 'undefined') return null;

    const nameLenPlus = name.length + 1;
    const cookieArray = document.cookie.split(';');

    for (let i = 0; i < cookieArray.length; i++) {
      let cookie = cookieArray[i].trim();
      if (cookie.substring(0, nameLenPlus) === name + '=') {
        return decodeURIComponent(cookie.substring(nameLenPlus));
      }
    }
    return null;
  },

  /**
   * Obtiene el Facebook Browser ID (fbp).
   * Identifica de forma única al navegador por 90 días.
   */
  getFbp(): string | null {
    return this.get('_fbp');
  },

  /**
   * Obtiene el Facebook Click ID (fbc).
   * Prioriza la cookie existente, si no, intenta construirlo desde el 'fbclid' de la URL.
   * @returns string en formato 'fb.1.{timestamp}.{fbclid}' o null
   */
  getFbc(): string | null {
    if (typeof window === 'undefined') return null;

    // 1. Intentar obtenerlo de la cookie oficial
    const cookieFbc = this.get('_fbc');
    if (cookieFbc) return cookieFbc;

    // 2. Fallback: Construirlo manualmente desde el parámetro de la URL
    // Útil para el primer evento (PageView) antes de que el script de Meta se inicialice
    const urlParams = new URLSearchParams(window.location.search);
    const fbclid = urlParams.get('fbclid');

    if (fbclid) {
      const creationTime = Date.now();
      return `fb.1.${creationTime}.${fbclid}`;
    }

    return null;
  },
};
